import { CheckOutlined } from "@ant-design/icons";
import { Card, Modal } from "antd";
import React from "react";

const PriceWindow = (props) => {
    const {setShowPriceList, showPriceList, priceList=[]} = props;
    console.log(priceList);
    return <>
    <Modal 
    title="Plans & Pricing" 
    visible={showPriceList}
    contentBg="red"
      footer={null}
      width='90%'
      className="price_tier_window"
    //   header={null}
      onCancel={() => setShowPriceList(false)}
    >
        <div className="tier_wrapper" >
            {
                priceList.map((items)=>{
                    return <Card className="tier_card">
                    <h1 className="tier_name">{items?.name}</h1>
                    <div className="tier_price">
                        <span className="price">${items?.monthly_price}</span>
                        <span className="price_label">/month</span>
                    </div>
                    <div>
                        {
                            items?.available_features.split(',').map((featr)=>{
                                return <div className="tier_options">
                                <span className="opt_icon"><CheckOutlined /></span>
                                <div className="opt_name">{featr}</div>
                            </div>
                            })
                        }
                    </div>
                    <div className="tier_footer"><button className="plan_btn" type="button">Choose Plan</button></div>
                </Card>
                })
            }
        </div>
    </Modal>
    </>
};
export default PriceWindow;